var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label.length)?_c('label',{staticClass:"block text-gray-500",class:_vm.getTextSizeBySize},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.showRequiredMark)?_c('span',{staticClass:"text-red-300"},[_vm._v("*")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }